export default __webpack_public_path__ + "static/media/culture.e376022f.svg";